import { useRoleStore } from '../store/roleStore';
import type { ModuleId, ModuleAccess, PermissionLevel } from '../types/rbac';
import { toModuleAccess, FULL_ACCESS, NO_ACCESS } from '../types/rbac';

export function usePermission(moduleId: ModuleId): ModuleAccess {
  const myRole = useRoleStore(s => s.myRole);
  const demoRole = useRoleStore(s => s.demoRoleOverride);
  const isLoaded = useRoleStore(s => s.isLoaded);
  const effectiveRole = demoRole ?? myRole;

  if (effectiveRole?.roleSlug === 'super_admin' || effectiveRole?.roleSlug === 'eoc_director') {
    return FULL_ACCESS;
  }

  if (!isLoaded) return FULL_ACCESS;
  if (!effectiveRole) return NO_ACCESS;

  const level: PermissionLevel = effectiveRole.permissions[moduleId] ?? 'none';
  return toModuleAccess(level);
}
